
const Favorites = () => {
    return null;
}

export default Favorites;
